<template>
  <header class="header">
    <div class="top">
      <b-container>
        <b-row>
          <b-col>
            <router-link :to="{ name: 'Home' }">
              <img
                class="header-logo"
                @click="toggleMenu = false"
                :src="require('@/assets/img/absi_logo.svg')"
                alt="absi logo, gå til forside"
              />
            </router-link>
          </b-col>

          <b-col class="d-lg-none d-flex justify-content-end">
            <b-button
              class="nav-burger-menu"
              variant="outline"
              @click="toggleMenu = !toggleMenu"
            >
              <div id="burger-toggle" :class="{ 'burger-active': toggleMenu }">
                <span></span>
                <span></span>
                <span></span>
              </div>
            </b-button>
          </b-col>
        </b-row>
      </b-container>
    </div>

    <div class="bottom d-none d-lg-block">
      <b-container>
        <b-row>
          <b-col>
            <the-nav-desktop
              :error-msg="errorMessage"
              :nav-links="navigationLinks"
            ></the-nav-desktop>
          </b-col>
        </b-row>
      </b-container>
    </div>

    <the-nav-mobile
      :error-msg="errorMessage"
      :nav-links="navigationLinks"
      @closeMenu="toggleMenu = false"
      :toggle-menu="toggleMenu"
      class="d-lg-none"
    ></the-nav-mobile>
  </header>
</template>

<script>
import TheNavMobile from "@/components/nav/TheNavMobile.vue";
import TheNavDesktop from "@/components/nav/TheNavDesktop.vue";

export default {
  name: "Header",
  components: {
    TheNavMobile,
    TheNavDesktop,
  },
  props: {
    navigationLinks: {
      type: Array,
      required: true,
    },
    errorMessage: {
      type: Boolean,
    },
  },
  data() {
    return {
      toggleMenu: false,
      windowWidth: window.innerWidth,
    };
  },
  watch: {
    toggleMenu() {
      // Checking to see the boolean togglemenu and adding or removing overflow-hidden(bootstrap)
      if (this.toggleMenu) {
        this.toggleBodyClass("addClass", "overflow-hidden");
        return;
      }
      this.toggleBodyClass("removeClass", "overflow-hidden");
    },
    windowWidth() {
      // Checking the size of the window width and changing the class based on the size
      if (this.windowWidth > 974) {
        this.toggleMenu = false;
      }
    },
    errorMessage() {
      if (this.windowWidth > 974) {
        if (this.errorMessage) {
          this.toggleMenu = false;
        }
      } else {
        if (this.errorMessage) {
          this.toggleMenu = true;
        }
      }
    },
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener("resize", this.onResize); // Adding event listener on resize and adding data to function
    });
  },

  beforeDestroy() {
    window.removeEventListener("resize", this.onResize); // Removing event the-listener on resize, and adding data to function
  },
  methods: {
    toggleBodyClass(addRemoveClass, className) {
      // Adding and removing a class to the body
      const el = document.body;
      if (addRemoveClass === "addClass") {
        el.classList.add(className);
      } else {
        el.classList.remove(className);
      }
    },
    onResize() {
      this.windowWidth = window.innerWidth;
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  max-width: 100% !important;
}
.header {
  background-color: $secondary;
  z-index: 2;
  position: relative;
  width: 100%;
  box-shadow: -1px 1px 3px #888888;

  .top {
    border-bottom: $border-header;

    .nav-burger-menu {
      color: $primary;
      &:focus {
        box-shadow: none !important;
      }

      #burger-toggle {
        span {
          display: block;
          width: 33px;
          height: 4px;
          position: relative;

          background: $primary;
          border-radius: 3px;

          transform-origin: 4px 0px;

          transition: transform 0.5s cubic-bezier(0.77, 0.2, 0.05, 1),
            background 0.5s cubic-bezier(0.77, 0.2, 0.05, 1), opacity 0.55s ease;

          &:first-child {
            transform-origin: 0% 0%;
            margin-bottom: 5px !important;
          }

          &:nth-last-child(2) {
            transform-origin: 0% 100%;
            margin-bottom: 5px;
          }
          &:nth-last-child(3) {
            margin-bottom: 0;
          }
        }
      }

      .burger-active {
        span {
          opacity: 1;
          transform: rotate(-45deg) translate(0, -1px);
          background: $senary !important;

          &:nth-last-child(2) {
            opacity: 0;
            transform: rotate(0deg) scale(0.2, 0.2);
          }

          &:nth-last-child(3) {
            transform: rotate(45deg) translate(0, -4px);
          }
        }
      }
    }
  }
}

.header-logo {
  width: 115px;
  margin: 14px 0;
}

@media (min-width: 993px) {
  .container {
    max-width: 600px !important;
  }

  .header {
    border-bottom: none !important;

    .top {
      border-bottom: $border-header;
    }
  }
}
</style>